export const getLayouts = () => ({
    'default': {
        assets: ['Carteira_retorno']
    },
});
